import React, { useEffect, useState } from 'react';
import { inputs, feedback } from '@ecosystem/newron-design-system';
const { Tooltip } = feedback;
import { NumericRangeConfigItem } from '../types';
import { ConfigItemElementProps } from './types';

const { NumberInput } = inputs;

function NumericRangeElement({
  configItem: { key, label, options, value, tooltipInfo, description, disabled },
  onChange,
}: ConfigItemElementProps<NumericRangeConfigItem>) {
  const { min: minOption, max: maxOption } = options || {};
  const [min, setMin] = useState<number>();
  const [max, setMax] = useState<number>();

  useEffect(() => {
    setMin(value?.min ?? null);
    setMax(value?.max ?? null);
  }, [value?.min, value?.max]);

  const handleMinBlur = () => {
    if (min === null && max === null) {
      onChange(key, {});
    } else if (min < 0) {
      setMin(null);
      if (max !== null) {
        onChange(key, { max });
      } else {
        onChange(key, {});
      }
    } else if (min && min >= 0 && min > max) {
      setMax(null);
      onChange(key, { min });
    } else {
      onChange(key, { min, max });
    }
  };

  const handleMaxBlur = () => {
    if (min === null && max === null) {
      onChange(key, {});
    } else if (max < 0) {
      setMax(null);
      if (min !== null) {
        onChange(key, { min });
      } else {
        onChange(key, {});
      }
    } else if (max && max >= 0 && min > max) {
      setMin(null);
      onChange(key, { max });
    } else {
      onChange(key, { min, max });
    }
  };

  return (
    <div className="relative">
      {tooltipInfo ? (
        <Tooltip placement="top">
          <Tooltip.Content>{tooltipInfo}</Tooltip.Content>
          <span
            className="text-md font-bold flex-grow text-heading pb-1"
            style={{
              textDecoration: '1px dashed underline',
              textUnderlineOffset: '4px',
            }}
          >
            {label}
          </span>
        </Tooltip>
      ) : (
        <div className="text-md font-bold flex-grow text-heading pb-1">{label}</div>
      )}
      <div className={description ? 'flex-column gap-2 mt-2' : ''}>
        {description && (
          <div className="text-sm text-lighter line-truncate" role="presentation">
            {description}
          </div>
        )}

        <div className="flex items-start gap-2">
          <NumberInput
            helperText={`Min: ${minOption ?? 0}`}
            value={min}
            minValue={minOption}
            maxValue={maxOption}
            disabled={disabled}
            onChange={setMin}
            onBlur={handleMinBlur}
          />
          <span className="pt-3">—</span>
          <NumberInput
            helperText={`Max: ${maxOption ?? 0}`}
            value={max}
            minValue={minOption}
            maxValue={maxOption}
            disabled={disabled}
            onChange={setMax}
            onBlur={handleMaxBlur}
          />
        </div>
      </div>
    </div>
  );
}

export { NumericRangeElement };
